export default "__VITE_ASSET__PamWqwp9__"